import { useDeviceType } from '@cian/ui-kit';
import clsx from 'clsx';
import * as React from 'react';

import * as styles from './Utilities.css';

interface IUtilitiesProps {
  testId: string;
  children: React.ReactNode;
}

export const Utilities: React.FC<IUtilitiesProps> = ({ testId, children }) => {
  const deviceType = useDeviceType();

  return (
    <div
      data-testid={testId}
      className={clsx(styles['container'], deviceType !== 'phone' && styles['container--desktop'])}
    >
      {children}
    </div>
  );
};
